﻿window.dxCompteClientPlan = null

window.cObjetCompteClientMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "compte client"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau compte client"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            if (objet.data.nom == null) { txt = "" }
            else { txt = objet.data.nom }
            if (objet.data.nom_contact != null) { txt += ((txt.length > 0) ? "/" : "") + objet.data.nom_contact }
            if (objet.data.prenom_contact != null) { txt += ((txt.length > 0) ? " " : "") + objet.data.prenom_contact }
            if (txt.length == 0) txt = objet.data.adresse_email
        }
        else {
            txt = "compte client"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetNom = function () {
        var txt = ""
        if (objet.data.nom == null) { txt = "" } else { txt = objet.data.nom }
        var nomPrenom = ""
        if (objet.data.nom_contact != null) { nomPrenom += objet.data.nom_contact }
        if (objet.data.prenom_contact != null) { nomPrenom += ((nomPrenom.length > 0) ? " " : "") + objet.data.prenom_contact }
        if (nomPrenom.length > 0) txt += ((txt.length > 0) ? "/" : "") + nomPrenom
        return txt
    }

    this.mGetLibNomPrenomFromDataTemplate = function (dataTemplate) {
        var txt = ""
        if (dataTemplate.nom_str == null || dataTemplate.nom_str.length == 0) { txt = "" }
        else {
            var txt = dataTemplate.nom_str;
        }
        return ((txt.length == 0) ? "(Pas de nom)" : txt)
    }

    this.mGetRadiusImage = function () { return "10" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data != 'undefined') {
            if (typeof objet.data.nom != 'undefined' && objet.data.nom == null) {
                if (typeof objet.data.nom_contact != 'undefined' && objet.data.nom_contact != null && objet.data.nom_contact.length > 0) { txt += objet.data.nom_contact[0] }
                if (typeof objet.data.prenom_contact != 'undefined' && objet.data.prenom_contact != null && objet.data.prenom_contact.length > 0) { txt += objet.data.prenom_contact[0] }
                else { if (typeof objet.data.nom_contact != 'undefined' && objet.data.nom_contact != null && objet.data.nom_contact.length > 1) txt += objet.data.nom_contact[1] }
            } else { txt = objet.data.nom.substring(0, 2); }
        } else {

        }
        return txt.toUpperCase();
    }

    this.mGetIcone = function (dataTemplate) {
        $Icone = $("<i class='fas fa-address-card'></i>");
        $Icone.attr("title", "Compte client")
        return $Icone
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.hasScrollPopup = function () { return false }
    this.contentTemplateSaisie = function (contentElement, option) {
        contentElement.css("padding", "5px 20px")
        if (typeof option == 'undefined') option = {}
        if (typeof option.reinitialise_pwd == 'undefined') option.reinitialise_pwd = true
        if (typeof option.precision_compte_client == 'undefined') option.precision_compte_client = true
        if (typeof option.site_web == 'undefined') option.site_web = true
        if (typeof option.tvaintra == 'undefined') option.tvaintra = true
        if (typeof option.nomsociete == 'undefined') option.nomsociete = true
        if (typeof option.nomprenom == 'undefined') option.nomprenom = true
        if (typeof option.ligneadresse == 'undefined') option.ligneadresse = true
        if (typeof option.cp == 'undefined') option.cp = true
        if (typeof option.ville == 'undefined') option.ville = true
        if (typeof option.pays == 'undefined') option.pays = true
        if (typeof option.email == 'undefined') option.email = true
        if (typeof option.tel == 'undefined') option.tel = true
        if (typeof option.mobile == 'undefined') option.mobile = true
        if (typeof option.showImage == 'undefined') option.showImage = false
        if (typeof option.showDetailDate == 'undefined') option.showDetailDate = false
        if (typeof option.showUrlConnect == 'undefined') option.showUrlConnect = false
        if (typeof option.showDossier == 'undefined') option.showDossier = false
        contentElement.empty();

        if (option.showDetailDate) {
            var $Table = $("<table/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Créé le'>Créé le</td>").appendTo($Tr)
            var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.dcr.toDateIlya() + " (" + objet.data.dcr.toFrenchDateTime() + ")</td>").appendTo($Tr)
            if (typeof objet.data.derniere_date_connexion != 'undefined' && objet.data.derniere_date_connexion != null) {
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Dernière connexion'>Dernière connexion</td>").appendTo($Tr)
                var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.derniere_date_connexion.toDateIlya() + " (" + objet.data.derniere_date_connexion.toFrenchDateTime() + ")</td>").appendTo($Tr)
            }
        }
        var items = []
        var lstCtrl = {}
        if (option.showImage) {
            var $DivImage = $("<div style='text-align:center;padding:5px;'/>").appendTo(contentElement)
            $("<div style='display:inline-block;'/>").appendTo($DivImage).dxCtrlImageData({
                bddCtrl: Me.objet.bddRef,
                data: objet.data,
                size: 120,
                showText: false
            })
        }
        if (option.nomsociete) {
            items.push({
                dataField: "nom", label: { location: "top", text: String.fromCharCode(8203) + "Nom" + ((option.precision_compte_client) ? "**" : ""), visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlTxtNomSociete = $("<div class='dxctrlfocus nom_societe'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Nom société" + ((option.precision_compte_client) ? "**" : ""),
                        value: objet.data.nom,
                        placeholder: "Nom de la société facturée...",
                        inputAttr: { autocomplete: 'test-autocomplete' },
                        onValueChanged: function (e) { objet.data.nom = e.value; objet.mSaveChamp("nom") }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
        }
        if (option.tvaintra) {
            items.push({
                label: { location: "top", text: "Tva intracommunautaire", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlTvaIntra = $("<div class='tvaintra'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "N° Tva intracommunautaire",
                        placeholder: "Non applicable",
                        value: objet.data.tva_intra,
                        onValueChanged: function (e) {
                            objet.data.tva_intra = e.value;
                            objet.mSaveChamp("tva_intra");
                        }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
        }
        if (option.nomprenom) {
            items.push({
                dataField: "nom_contact", label: { location: "top", text: String.fromCharCode(8203) + "Nom du contact", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlTxtNomContact = $("<div class='nom_contact'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Nom du contact" + ((option.precision_compte_client) ? "**" : ""),
                        value: objet.data.nom_contact,
                        placeholder: "Nom...",
                        inputAttr: { autocomplete: 'test-autocomplete' },
                        onValueChanged: function (e) { objet.data.nom_contact = e.value; objet.mSaveChamp("nom_contact") }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
            items.push({
                dataField: "prenom_contact", label: { location: "top", text: String.fromCharCode(8203) + "Prénom du contact", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlTxtPrenomContact = $("<div class='prenom_contact'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Prénom du contact" + ((option.precision_compte_client) ? "**" : ""),
                        value: objet.data.prenom_contact,
                        placeholder: "Prénom...",
                        inputAttr: { autocomplete: 'test-autocomplete' },
                        onValueChanged: function (e) { objet.data.prenom_contact = e.value; objet.mSaveChamp("prenom_contact") }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
        }
        if (option.ligneadresse) {
            items.push({
                dataField: "ad1", label: { location: "top", text: "Ligne d'adresse*", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlAdr = $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "N° et rue",
                        value: objet.data.ad1,
                        placeholder: "Ligne d'adresse...",
                        onValueChanged: function (e) {
                            objet.data.ad1 = e.value;
                            objet.data.recalcul_geocode = "1"
                            objet.mSave();
                        }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.cp) {
            items.push({
                dataField: "cp", label: { location: "top", text: "Code postal*", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlCp = $("<div class='cp'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Code postal" + ((option.precision_compte_client) ? "*" : ""),
                        value: objet.data.cp,
                        placeholder: "Code postal...",
                        onValueChanged: function (e) {
                            objet.data.cp = e.value;
                            objet.data.recalcul_geocode = "1"
                            objet.mSave();
                        }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 5, colSpanSm: 5, colSpanMd: 5, colSpanLg: 5
            })
        }
        if (option.ville) {
            items.push({
                dataField: "ville", label: { location: "top", text: "Ville*", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlVille = $("<div class='ville'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Ville" + ((option.precision_compte_client) ? "*" : ""),
                        value: objet.data.ville,
                        placeholder: "Ville...",
                        onValueChanged: function (e) {
                            objet.data.ville = e.value;
                            objet.data.recalcul_geocode = "1"
                            objet.mSave();
                        }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 6, colSpanSm: 6, colSpanMd: 6, colSpanLg: 6
            })
        }
        if (option.pays) {
            items.push({
                dataField: "pays", label: { location: "top", text: "Pays*", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlPays = $("<div class='pays'/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Pays" + ((option.precision_compte_client) ? "*" : ""),
                        value: objet.data.pays,
                        placeholder: "Pays...",
                        onValueChanged: function (e) {
                            objet.data.pays = e.value;
                            objet.data.recalcul_geocode = "1"
                            objet.mSave();
                        }
                    }).dxCtrlTextBox("instance");
                },
                colSpanXs: 5, colSpanSm: 5, colSpanMd: 5, colSpanLg: 5
            })
        }
        if (option.email) {
            items.push({
                dataField: "email", label: { location: "top", text: "email*", visible: false },
                template: function (itemData, itemElement) {
                    lstCtrl.dxCtrlEmail = Me.mGetCtrlAdresseEmail(itemElement, option)
                    //lstCtrl.dxCtrlEmail = $("<div/>").appendTo(itemElement).dxCtrlTextEmail({
                    //    labelMode: 'floating',
                    //    label: "Adresse mail" + ((option.precision_compte_client) ? "*" : ""),
                    //    name: "hkjgkhkj",
                    //    value: objet.data.adresse_email,
                    //    placeholder: "Saisissez l'adresse email de gestion (réception facture, information environnement)...",
                    //    maxLength: 500,
                    //    onValueChanged: function (e) {
                    //        if (e.value != objet.data.adresse_email) {
                    //            $("<div/>").appendTo("body").dxCtrlSaisieCode({
                    //                adresse_email: e.value,
                    //                title: "Confirmez votre email",
                    //                contentTemplateTop: function (contentElement) {
                    //                    $("<div>Un message avec un code d'identification vous a été envoyé sur l'adresse email <u>" + e.value + "</u>.<br/>Veuillez saisir le code reçu pour valider la modification de votre adresse email.</div>").appendTo(contentElement)
                    //                },
                    //                //contentTemplateBottom: function (contentElement) {
                    //                //    $("<div style='font-size:80%'><i>Je n'ai pas reçu le message</i></div>").appendTo(contentElement)
                    //                //    $("<div style='font-size:70%'><i>(Vérifiez dans vos courriers indésirables)</i></div>").appendTo(contentElement)
                    //                //},
                    //                onValide: function () {
                    //                    objet.data.adresse_email = e.value;
                    //                    objet.mSaveChamp("adresse_email");
                    //                },
                    //                onCancel: function () {
                    //                    e.component.option("value", objet.data.adresse_email)
                    //                    e.component.focus()
                    //                    mNotify("La saisie de votre adresse email a été annulée.", "warning", 6000)
                    //                }
                    //            })
                    //        }
                    //    }
                    //}).dxCtrlTextEmail("instance");
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.tel) {
            items.push({
                label: { location: "top", text: "Téléphone", visible: false },
                template: function (itemData, itemElement) {
                    var dataTel = {
                        tel_code_pays: objet.data.tel_code_pays,
                        tel_number: objet.data.tel_number,
                        tel_complet: objet.data.tel_complet,
                        tel_sms: objet.data.tel_sms,
                        tel_error: objet.data.tel_error,
                        tel_num_type: objet.data.tel_num_type
                    }
                    lstCtrl.dxCtrlTel = $("<div/>").appendTo(itemElement).dxCtrlTelephone({
                        labelMode: 'floating',
                        label: "Téléphone",
                        value: dataTel,
                        onValueChanged: function (e) {
                            objet.data.tel_code_pays = e.value.tel_code_pays;
                            objet.data.tel_number = e.value.tel_number;
                            objet.data.tel_complet = e.value.tel_complet;
                            objet.data.tel_sms = e.value.tel_sms;
                            objet.data.tel_error = e.value.tel_error;
                            objet.data.tel_num_type = e.value.tel_num_type;
                            objet.mSave();
                        }
                    }).dxCtrlTelephone("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
        }
        if (option.mobile) {
            items.push({
                label: { location: "top", text: "Mobile", visible: false },
                template: function (itemData, itemElement) {
                    var dataTel = {
                        tel_code_pays: objet.data.mob_code_pays,
                        tel_number: objet.data.mob_number,
                        tel_complet: objet.data.mob_complet,
                        tel_sms: objet.data.mob_sms,
                        tel_error: objet.data.mob_error,
                        tel_num_type: objet.data.mob_num_type
                    }
                    lstCtrl.dxCtrlMob = $("<div/>").appendTo(itemElement).dxCtrlTelephone({
                        labelMode: 'floating',
                        label: "Mobile",
                        typeTel: "mob",
                        value: dataTel,
                        onValueChanged: function (e) {
                            objet.data.mob_code_pays = e.value.tel_code_pays;
                            objet.data.mob_number = e.value.tel_number;
                            objet.data.mob_complet = e.value.tel_complet;
                            objet.data.mob_sms = e.value.tel_sms;
                            objet.data.mob_error = e.value.tel_error;
                            objet.data.mob_num_type = e.value.tel_num_type;
                            objet.mSave();
                        }
                    }).dxCtrlTelephone("instance");
                },
                colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
            })
        }
        if (option.site_web) {
            items.push({
                label: { location: "top", text: "Site web", visible: false },
                template: function (itemData, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Site web",
                        value: objet.data.site_web,
                        onValueChanged: function (e) {
                            objet.data.site_web = e.value;
                            objet.mSaveChamp("site_web");
                        }
                    });
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.showDossier) {
            items.push({
                label: { location: "top", text: "Dossier", visible: false },
                template: function (itemData, itemElement) {
                    //lstCtrl.dxCtrlDossier = $("<div class='dossier'/>").appendTo(itemElement).dxCtrlTagBoxDossier({
                    //    bddCtrl: Me.objet.bddRef,
                    //    labelMode: 'floating',
                    //    label: "Dossier",
                    //    id_table: objet.mGetTable().id_table,
                    //    id: objet.cle(),
                    //    onValueChanged: function (e) {
                    //    }
                    //}).dxCtrlTagBoxDossier("instance");
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
            if (objet.data.nom_base != null && objet.data.nom_base.length > 0) {
                items.push({
                    label: { location: "top", text: "Type plan", visible: false },
                    template: function (itemData, itemElement) {
                        var lstOffre = JSON.parse(JSON.stringify(Me.objet.bddRef.tarif.lst_offre))
                        lstOffre.unshift({
                            id_type_offre: 0,
                            nom: "Période d'essai"
                        })
                        lstCtrl.dxCtrlTypePlan = $("<div/>").appendTo(itemElement).dxCtrlSelectBox({
                            labelMode: 'floating',
                            label: "Type offre",
                            dataSource: lstOffre,
                            displayExpr: "nom",
                            valueExpr: "id_type_offre",
                            value: parseInt(objet.data.offre_id_type),
                            onValueChanged: function (e) {
                                objet.data.offre_id_type = e.value.id_type_offre
                                Me.objet.bddRef.getObjet(objet.data).mSaveChamp("offre_id_type")
                            },
                            onContentReady: function (e) {
                                e.component.element().css("border-color", ((objet.data.offre_id_type == "0") ? "orange" : "green"))
                                e.component.element().css("border-width", "3px")
                                e.component.element().css("border-style", "solid")
                            }
                        }).dxCtrlSelectBox("instance");
                    },
                    colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
                })
                items.push({
                    label: { location: "top", text: "date fin plan", visible: false },
                    template: function (itemData, itemElement) {
                        lstCtrl.dxCtrlDateFinPlan = $("<div/>").appendTo(itemElement).dxCtrlDateBox({
                            labelMode: 'floating',
                            label: "Date fin offre",
                            value: objet.data.offre_date_fin,
                            onValueChanged: function (e) {
                                objet.data.offre_date_fin = e.value
                                Me.objet.bddRef.getObjet(objet.data).mSaveChamp("offre_date_fin")
                            },
                            onContentReady: function (e) {
                                e.component.element().css("border-color", ((objet.data.date_fin_plan < parametre.date_now) ? "red" : "green"))
                                e.component.element().css("border-width", "3px")
                                e.component.element().css("border-style", "solid")
                            }
                        }).dxCtrlDateBox("instance");
                    },
                    colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
                })
                items.push({
                    label: { location: "top", text: "Périodicité plan", visible: false },
                    template: function (itemData, itemElement) {
                        lstCtrl.dxCtrlPeriodicitePlan = $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
                            labelMode: 'floating',
                            label: "Pérodicité de l'offre commandé (en mois)",
                            value: objet.data.offre_periodicite,
                            disabled: true
                        }).dxCtrlNumberBox("instance");
                    },
                    colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
                })
                items.push({
                    label: { location: "top", text: "Nb acces plan", visible: false },
                    template: function (itemData, itemElement) {
                        lstCtrl.dxCtrlNbAccesPlan = $("<div/>").appendTo(itemElement).dxCtrlNumberBox({
                            labelMode: 'floating',
                            label: "Nbre accès dans offre",
                            value: objet.data.offre_nb_acces,
                            onValueChanged: function (e) {
                                objet.data.offre_nb_acces = e.value
                                Me.objet.bddRef.getObjet(objet.data).mSaveChamp("offre_nb_acces")
                            }
                        }).dxCtrlNumberBox("instance");
                    },
                    colSpanXs: 8, colSpanSm: 8, colSpanMd: 8, colSpanLg: 8
                })
                //items.push({
                //    label: { location: "top", text: "Liste fonctionnalité", visible: false },
                //    template: function (itemData, itemElement) {
                //        if (objet.data.nom_base != null && objet.data.nom_base.length > 0) {
                //            var bddCptCli = new cBdd(objet.data.nom_base)
                //            bddCptCli.mInit(function () {
                //                var lstFonctionnalite = []
                //                if (objet.data.offre_id_type == 0) {
                //                    lstFonctionnalite = bddCptCli.tarif.lst_fonctionnalite.filter(function (fonctionnnalite) {
                //                        return bddCptCli.objCptCli.objetMetier.mGetLstIdTypeFonctionnaliteEssai().contains(fonctionnnalite.id_type_fonctionnalite)
                //                    })
                //                } else {
                //                    lstFonctionnalite = bddCptCli.tarif.lst_fonctionnalite.filter(function (fonctionnnalite) {
                //                        return bddCptCli.objCptCli.objetMetier.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == fonctionnnalite.id_type_fonctionnalite }).length > 0
                //                    })
                //                }
                //                var txt = ""
                //                lstFonctionnalite.forEach(function (dataFonct) {
                //                    txt += ((txt.length > 0) ? " &bull; " : "") + dataFonct.nom
                //                })
                //                itemElement.html(txt)
                //            })
                //        } else { itemElement.html("(Aucune base de données)") }

                //    },
                //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                //})
                items.push({
                    label: { location: "top", text: "BDD", visible: false },
                    template: function (itemData, itemElement) {
                        $("<div style='width:100%'/>").appendTo(itemElement).dxCtrlButton({
                            text: "Supprimer la bdd",
                            width: "100%",
                            onClick: function (e) {
                                var timeoutSupp = null
                                var nbSec = 10
                                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                    target: e.component.element(),
                                    width: 300,
                                    contentTemplate: function (contentElement) {
                                        contentElement.css("padding", "25px")
                                        $("<div>ATTENTION!!!!!!<br/>Vous allez supprimer définitivement<br/>un environnement client<br/>Confirmez</div>").appendTo(contentElement)
                                        $("<div style='width:100%'/>").appendTo(contentElement).dxButton({
                                            text: "Confirmez",
                                            width: "100%",
                                            onClick: function (e) {
                                                if (e.component.option("text") == "Confirmez") {
                                                    function mComptage() {
                                                        if (nbSec < 0) { return }
                                                        else if (nbSec == 0) {
                                                            var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
                                                            jauge.mShow()
                                                            e.component.option("text", "Suppression...")
                                                            e.component.option("disabled", true)
                                                            timeoutSupp = null
                                                            objet.bddRef.mAjaxCall({
                                                                command: "delenvironnementfromgestion",
                                                                nom_base_to_del: objet.data.nom_base,
                                                                id_compte_client: objet.data.id_compte_client
                                                            }, function (data) {
                                                                mNotify("L'environnement a été supprimé", "warning", 15000)
                                                                tt.hide()
                                                                page.mRemovePopup(objet.data)
                                                            })
                                                        } else {
                                                            nbSec -= 1
                                                            e.component.option("text", "Annuler (supp. dans " + nbSec + "s)")
                                                            timeoutSupp = window.setTimeout(function () { mComptage() }, 1000)
                                                        }
                                                    }
                                                    mComptage()
                                                } else {
                                                    tt.hide()
                                                    nbSec = -100
                                                    window.clearTimeout(timeoutSupp)
                                                    mNotify("La suppression a été annulée", "error", 15000)
                                                }

                                            }
                                        })
                                    },
                                    onHiding: function (e) {
                                        if (timeoutSupp != null) {
                                            nbSec = -100
                                            window.clearTimeout(timeoutSupp)
                                            mNotify("La suppression a été annulé", "error", 15000)
                                        }
                                    }
                                }).dxCtrlTooltip("instance")
                                tt.show()
                            }
                        });
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })
            } else {
                items.push({
                    label: { location: "top", text: "Liste fonctionnalité", visible: false },
                    template: function (itemData, itemElement) {
                        itemElement.html("(Aucune base de données)")
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })
            }
        }
        if (option.reinitialise_pwd) {
            items.push({
                label: { location: "top", text: "", visible: false },
                template: function (itemData, itemElement) {
                    $("<div style='width:100%'/>").appendTo(itemElement).dxCtrlButton({
                        text: "Réinitialiser votre mot de passe",
                        width: "100%",
                        onClick: function (e) {
                            if (Me.objet.bddRef.nom_base == parametre.code_appli + "_aagest") {
                                mNotify("Vous ne pouvez pas faire une demande de réinitialisation de mot de passe sur l'environnement gestionnaire.", "error", 15000)
                            } else {
                                jaugeDemarrage.mShow();
                                var dataToBeSent = {
                                    command: 'demandereinitpwdwithid',
                                    adresse_email: objet.data.adresse_email,
                                    nom_table: "compte_client",
                                    id: objet.data.id_compte_client
                                }
                                var url = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
                                $.post(url, dataToBeSent, function (data) {
                                    if (data.root.resultat == "ok") {
                                        if (data.root.emailenvoye == "1") {
                                            mNotify("Un email vous permettant de réinitialiser votre mot de passe vous a été envoyé. Veuillez consulter vos emails et suivre les instructions.<br/>(Si vous ne recevez pas notre email, vérifiez que celui-ci ne se trouve pas dans vos courriers indésirables)", "success", 10000)
                                        } else {
                                            mNotify("Impossible de vous envoyer un email de réinitialisation.", "error", 15000)
                                        }
                                    }
                                    else {
                                        if (typeof data.root.message != 'undefined') { mNotify(data.root.message, "error", 5000) }
                                        else { mNotify("Impossible d'envoyer l'email de réinitialisation.", "error", 15000); }
                                    }
                                }, 'json')
                                    .fail(function (data) {
                                        console.log(data.responseText)
                                        mNotify("Impossible d'envoyer l'email de réinitialisation.", "error", 15000);
                                    })
                                    .always(function (data) {
                                        jaugeDemarrage.mHide();
                                    });
                            }
                        }
                    });
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            })
        }
        if (option.precision_compte_client) {
            $("<div style='font-size:80%;font-style:italic;' class='indication'>Le compte client repésente les coordonnées sur la base desquelles est généré toutes vos factures<br/>(*) obligatoire.<br/>(**) Si vous êtes un particulier, ne remplir que <b>Nom & prénom</b>, Si vous êtes une société, remplir le <b>Nom société</b>.</div>").appendTo(contentElement)
        }

        if (Me.objet.bddRef.nom_base.endsWith("_aagest") && option.show_warning_form) {
            $("<div style='margin:5px'/>").appendTo(contentElement).dxCtrlWarningForm({
                type: "error",
                html: function () { return "<div style='font-size:80%;'><b>ATTENTION</b><br/>Les modifications sur le compte client sont reportées directement sur le compte client.<br/>Ne faite des modifications que si cela se fait en accord avec le client ou que vous êtes sûr de votre modification.</div>" }
            })
        }

        var $Div = $("<div/>").appendTo(contentElement)
        var blocForm = $("<div/>").appendTo($Div).dxCtrlForm({
            formData: objet.data,
            items: items,
            visible: true
        }).dxCtrlForm("instance");

        return lstCtrl
    }

    this.mGetCtrlAdresseEmail = function (container, option) {
        var lstEmail = []
        Me.objet.bddRef.mAjaxCall({ command: "getlstemailcompteclient" }, function (data) {
            if (typeof data.email == "undefined") data.email = []
            data.email.forEach(function (mail) {
                if (mail != objet.data.adresse_email) lstEmail.push(mail)
            });
        });
        var disableValueChangedEmail = false
        var dxTxtBoxEmail = $("<div/>").appendTo(container).dxCtrlTextEmail({
            labelMode: 'floating',
            label: "Adresse mail" + ((option.precision_compte_client) ? "*" : ""),
            name: "hkjgkhkj",
            value: objet.data.adresse_email,
            placeholder: "Saisissez l'adresse email de gestion (réception facture, information environnement)...",
            maxLength: 500,
            onValueChanged: function (e) {
                if (disableValueChangedEmail) return
                if (e.value != objet.data.adresse_email) {
                    //on vérifie n'est pas déjà affilié à un compte client
                    if (lstEmail.contains(e.value)) {
                        mNotify("Cette adresse email est déjà liée à un compte client, vous ne pouvez pas l'utiliser.", "warning", 6000)
                        e.component.option("value", objet.data.adresse_email)
                    } else {
                        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                            bddCtrl: Me.objet.bddRef,
                            adresse_email: e.value,
                            title: "Confirmez votre email",
                            from: "saisie compte client (cObjetCompteClientMetier)",
                            contentTemplateTop: function (contentElement) {
                                $("<div>Un message avec un code d'identification vous a été envoyé sur l'adresse email <u>" + e.value + "</u>.<br/>Veuillez saisir le code reçu pour valider la modification de votre adresse email.</div>").appendTo(contentElement)
                            },
                            onValide: function () {
                                objet.data.adresse_email = e.value;
                                objet.mSaveChamp("adresse_email");
                            },
                            onCancel: function () {
                                disableValueChangedEmail = true
                                e.component.option("value", objet.data.adresse_email)
                                disableValueChangedEmail = false
                                e.component.focus()
                                mNotify("La saisie de votre adresse email a été annulée.", "warning", 6000)
                            }
                        })
                    }
                }
            }
        }).dxCtrlTextEmail("instance");
        return dxTxtBoxEmail
    }

    this.mGetContentListFactureClient = function (contentElement) {
        Me.objet.bddRef.mAjaxCall({ command: "getlstfacturefromclient", id_compte_client: objet.data.id_compte_client }, function (data) {
            if (typeof data.doc_cpt == 'undefined') data.doc_cpt = []
            var optGrid = {
                dataSource: new DevExpress.data.DataSource({
                    store: data.doc_cpt,
                    reshapeOnPush: true
                }),
                getMaxHeight: function () { return $("body").innerHeight() - 400 },
                showColumnHeaders: false,
                noDataText: "Aucune facture",
                rowClickable: true,
                width: "100%",
                //noDataText: "Aucun appareil",
                hoverStateEnabled: true,
                selection: { mode: "single" },
                onKeyDown: function (e) { if (e.event.keyCode == 13) e.handled = true; },
                columns: [{
                    caption: "Date", dataType: 'date', width: 110, sortOrder: "desc",
                    cellTemplate: function (cellElement, cellInfo) {
                        cellElement.html(cellInfo.data.date_document.toFrenchDateTime(true))
                    }
                }, {
                    caption: "Facture", dataType: 'string', width: "100%",
                    cellTemplate: function (cellElement, cellInfo) {
                        cellElement.html(Me.objet.bddRef.getObjet(cellInfo.data).mGetLib1())
                    }
                }, {
                    caption: "Mt", dataType: 'string', width: "100px",
                    cellTemplate: function (cellElement, cellInfo) {
                        cellElement.css("text-align", "right")
                        cellElement.html(parseFloat(cellInfo.data.totttc_avec_remise_pied).round().formatDisplay() + "€")
                    }
                }],
                onRowClick: function (e) {
                    jaugeDemarrage.mShow()
                    Me.objet.bddRef.mAjaxCall({ command: "generepdfdoccptfromclient", id_doc_cpt: e.data.id_doc_cpt }, function (data) {
                        window.open(data.urldoccpt)
                        jaugeDemarrage.mHide()
                    })
                },
                iconeElement: "fafa fafa-file-invoice-euro"
            }
            var dxGrid = $("<div/>").appendTo(contentElement).dxCtrlGridSimple(optGrid).dxCtrlGridSimple("instance");
        });
    }

    this.infoBaseRempli = function () {
        if (typeof objet.data.nom == 'undefined' || objet.data.nom == null || objet.data.nom.length == 0 ||
            typeof objet.data.nom_contact == 'undefined' || objet.data.nom_contact == null || objet.data.nom_contact.length == 0 ||
            typeof objet.data.prenom_contact == 'undefined' || objet.data.prenom_contact == null || objet.data.prenom_contact.length == 0 ||
            typeof objet.data.ville == 'undefined' || objet.data.ville == null || objet.data.ville.length == 0 ||
            typeof objet.data.pays == 'undefined' || objet.data.pays == null || objet.data.pays.length == 0 ||
            typeof objet.data.tva_intra == 'undefined' || objet.data.tva_intra == null || objet.data.tva_intra.length == 0 ||
            ((typeof objet.data.tel_sms == 'undefined' || objet.data.tel_sms == null || objet.data.tel_sms.length == 0) &&
                (typeof objet.data.mob_sms == 'undefined' || objet.data.mob_sms == null || objet.data.mob_sms.length == 0))) {
            return false;
        }
        return true;
    }

    this.mGetWidthPopup = function () { return 550 }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    if (typeof option.fullScreen == 'undefined') option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged,
            optionPopup: option,
            getUrl: function (funcOk) {
                objet.mGetDataTemplate([], function (dataTemplate) {
                    if (dataTemplate.site_web != null && dataTemplate.site_web.length > 0) { funcOk(dataTemplate.site_web) }
                    else { funcOk(objet.mGetLib1()) }
                })
            }
        })
        //contentElement.closest(".dx-scrollable").css("padding", "3px 5px 0 10px")
        //contentElement.dxCtrlPopupContentCompteClient({
        //    objet: objet,
        //    onSelectionChanged: option.onSelectionChanged
        //})
    }

    this.mGetChampTableDataUnitaire = function (chpTableData) {
        return null
    }

    this.mGetDataItemTemplate = function (funcOk) {
        var adr = Me.mGetAdrPostaleMiseEnForme(true)
        var tel = Me.mGetTelephoneMiseEnForme()
        var mobile = Me.mGetMobileMiseEnForme()
        var email = ((objet.data.adresse_email == null) ? "" : objet.data.adresse_email)
        var site = ((objet.data.site_web == null) ? "" : objet.data.site_web)
        funcOk({
            adr: adr,
            tel: tel,
            mobile: mobile,
            email: email,
            site: site
        })
    }

    this.mGetAdrPostaleMiseEnForme = function (court) {
        if (typeof court == 'undefined') court = false
        var adr = ""
        if (!court && objet.data.ad1 != null && objet.data.ad1.length > 0) adr = objet.data.ad1
        if (objet.data.cp != null && objet.data.cp.length > 0) adr += ((adr.length > 0) ? ", " : "") + objet.data.cp
        if (objet.data.ville != null && objet.data.ville.length > 0) adr += ((adr.length > 0) ? " " : "") + objet.data.ville
        if (objet.data.pays != null && objet.data.pays.length > 0) adr += ((adr.length > 0) ? ", " : "") + objet.data.pays
        return adr
    }

    this.mGetTelephoneMiseEnForme = function () {
        if (objet.data.tel_sms != null && objet.data.tel_sms.length > 0) {
            var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == objet.data.tel_code_pays })[0]
            return indicatif.dial_code + " " + msAddCaractereTel(objet.data.tel_sms, ".")
        } else { return "" }
    }

    this.mGetMobileMiseEnForme = function () {
        if (objet.data.mob_sms != null && objet.data.mob_sms.length > 0) {
            var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == objet.data.mob_code_pays })[0]
            return indicatif.dial_code + " " + msAddCaractereTel(objet.data.mob_sms, ".")
        } else { return "" }
    }

    this.mHasPubEmail = function () {
        return objet.data.date_fin_email_pub == null || objet.data.date_fin_email_pub < parametre.dateNow
    }

    //this.mSendEmailDemandeInfo = function (emailDest, emailExp, sujetEmail, sujetHtml, message, onSend, jauge) {
    //    var urlEnv = document.URLRacine
    //    var nomEntreprise = ((objet.data.nom) ? objet.data.nom : "")
    //    var villeEntreprise = ((objet.data.ville) ? objet.data.ville : "")
    //    var paysEntreprise = ((objet.data.pays) ? objet.data.pays : "")
    //    var telEntreprise = ((objet.data.tel_sms) ? objet.data.tel_sms : "")
    //    var nomPrenomUti = ((Me.objet.bddRef.utiCourant.nom) ? Me.objet.bddRef.utiCourant.nom : "").toUpperCase() + " " + ((Me.objet.bddRef.utiCourant.prenom) ? Me.objet.bddRef.utiCourant.prenom : "")
    //    var telUti = ((Me.objet.bddRef.utiCourant.tel_sms) ? Me.objet.bddRef.utiCourant.tel_sms : "")
    //    var htmlBody = "<div style='font-size:140%;'>" + sujetHtml + "</div>" +
    //        "<div style='font-size:120%;'>Url environnement: <b><a href='" + urlEnv + "' target='_blank'>" + urlEnv + "</a></b></div>" +
    //        "<div>Entreprise: <b>" + nomEntreprise + "(" + villeEntreprise + "/" + paysEntreprise + " - " + telEntreprise + ")</b></div>" +
    //        "<div>Utilisateur: <b>" + nomPrenomUti + " (" + telUti + " - " + emailExp + ")</b></div>" +
    //        "<br/><br/><br/>" +
    //        "<div><b>Message de l'utilisateur:</b><br/><i>" + message + "</i></div>"
    //    Me.objet.bddRef.mAjaxCall({
    //        command: "sendmail",
    //        sujet: sujetEmail,
    //        body: htmlBody,
    //        email_destinataire: emailDest,
    //        email_expediteur: emailExp,
    //        email_suivi: parametre.email_tracking
    //    },
    //        function (data) {
    //            if (data.envoye == "1") {
    //                mNotify("Votre message a été envoyé", "success", 4000); tt.hide();

    //                ////on envoi une confirmation à l'utilisateur
    //                //Me.objet.bddRef.mAjaxCall({
    //                //    command: "sendmail",
    //                //    sujet: "tr: " + sujetEmail,
    //                //    body: "<div>" + parametre.nom + "<br/>La demande ci-dessous à bien été envoyée<br/>Nous vous répondrons dans les plus brefs délais.<br/></div><hr/><br/>" + htmlBody,
    //                //    email_destinataire: emailExp,
    //                //    email_expediteur: emailDest,
    //                //    email_suivi: parametre.email_suivi
    //                //}, function () {

    //                //})

    //                if (typeof onSend != 'undefined') onSend();
    //            }
    //            else { mNotify("impossible d'enregistrer votre message", "error", 4000); }
    //        },
    //        function () {
    //            if (typeof jauge != 'undefined') jauge.mHide()
    //        },
    //        function () {
    //            mNotify("impossible d'enregistrer votre message", "error", 4000);
    //        });
    //}

    this.mGetLstDataCompteClientUtilisateur = function (funcOk) {
        //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "compte_client_utilisateur", sql: "select * from compte_client_utilisateur where id_compte_client=" + Me.data.id_compte_client }, function (data) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatascompteclientutilisateur", "id_compte_client": Me.data.id_compte_client }, function (data) {
            data.compte_client_utilisateur = JSON.parse(data.compte_client_utilisateur)
            //if (typeof data.compte_client_utilisateur == 'undefined') data.compte_client_utilisateur = [];
            funcOk(data.compte_client_utilisateur)
        });
    }

    //#region "GESTION GET DATA"
    this.mGetAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }
    this.mGetSiteDefaut = function () {
        return objet.data.site_web
    }

    this.mGetMobileDefaut = function () {
        var telSms = objet.data.tel_sms
        var tel = new cTelephone(null, telSms)
        return tel.mGetTelephoneDetail(telSms)
    }
    //#endregion "GESTION GET DATA"

    //#region "PLAN" 
    this.mGetHtmlDetailPlan = function (court) {
        var txt = ""
        if (objet.data.id_type_plan == 0) {
            txt = "Vous êtes en période d'essai"
        } else {
            txt = "Version" + ((court && objet.data.id_doc_cpt_en_cours == null) ? "<br/>" : " ") + "<b>" + planCourant.text + "</b>"
        }
        if (objet.data.id_doc_cpt_en_cours != null) txt += "<br/><i style='font-size:80%;opacity:0.5;'>Vous avez une commande en cours</i>"
        return txt
    }
    this.mGetHtmlDetailExpire = function (forcerDisplay) {
        var txtExpire = ""
        if (objet.data.date_fin_plan > (new Date())) { txtExpire = "Expirera " }
        else { txtExpire = "A expiré " }
        if (objet.data.id_type_plan == 0) {
            txtExpire = "<span style='color:red'>" + txtExpire + "" + objet.data.date_fin_plan.to235959().toDateIlya() + "</span>"
        } else {
            if (diffdate(new Date(), objet.data.date_fin_plan.to235959(), "d") <= 30) {
                if (diffdate(new Date(), objet.data.date_fin_plan.to235959(), "d") <= 7) {
                    txtExpire = "<span style='color:red'>" + txtExpire
                } else {
                    txtExpire = "<span style='color:orange'>" + txtExpire
                }
                txtExpire = txtExpire + "" + objet.data.date_fin_plan.to235959().toDateIlya() + "</span>"
            } else {
                if (forcerDisplay) { txtExpire = "<span style='color:green'>" + txtExpire + "" + objet.data.date_fin_plan.to235959().toDateIlya() + "</span>" }
                else { txtExpire = "" }
            }
        }
        return txtExpire
    }
    this.mGetHtmlAcces = function (clPlan) {
        var txt = ""
        if (typeof clPlan != 'undefined' && clPlan.lstTarifPlanMoisParElement.length > 1) {
            txt = objet.data.nb_element_plan + " " + clPlan.libNbElement + ((objet.data.nb_element_plan > 1) ? "s" : "") + " dans le plan<br/>"
        }
        var nbAccesPonctuel = Me.objet.bddRef.mGetArray("compte_client_acces").filter(function (cptCliAcces) { return new Date() >= cptCliAcces.date_debut.to000000() && new Date() <= cptCliAcces.date_fin.to235959() }).length
        txt += (parseInt(objet.data.nb_acces_plan) + nbAccesPonctuel) + " accès utilisateurs DONT<br/><div style='font-style:italic;font-size:70%;'>"
        txt += (objet.data.nb_acces_plan) + " accès dans le plan"
        if (nbAccesPonctuel > 0) {
            Me.objet.bddRef.mGetArray("compte_client_acces").filter(function (cptCliAcces) { return new Date() >= cptCliAcces.date_debut.to000000() && new Date() <= cptCliAcces.date_fin.to235959() }).forEach(function (acces) {
                txt += "<br/>+ 1 accès ponctuel du " + acces.date_debut.to000000().toDDMMMAA() + " au " + acces.date_fin.to235959().toDDMMMAA() + ""
            })
        }
        txt += "</div>"
        return txt
    }
    this.mShowTooltipVerifEssaiDocCpt = function (target, idTypeCom, textBt, funcValide) {
        if (this.data.offre_essai == "1") {
            var isValidate = false
            if (target && target.closest("body").length > 0) {
                popVisu = $("<div/>").appendTo("body").dxCtrlTooltip({
                    width: 450,
                    target: target,
                    contentTemplate: function (contentElement) {
                        contentTemplate(contentElement)
                    },
                    onHiding: function (e) {
                        if (!isValidate) jaugeDemarrage.mHide()
                    }
                }).dxCtrlTooltip("instance")
                popVisu.show()
            } else {
                popVisu = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    showMaximize: false,
                    height: "auto",
                    width: 500,
                    contentTemplate: function (contentElement) {
                        contentTemplate(contentElement)
                    },
                    onHiding: function (e) {
                        if (!isValidate) jaugeDemarrage.mHide()
                    }
                }).dxCtrlPopupBase("instance")
                popVisu.show()
            }
            function contentTemplate(contentElement) {
                contentElement.css("padding", "15px")
                contentElement.css("font-size", "120%")
                contentElement.css("white-space", "normal")
                $("<div><span style='font-size:120%;'>Vous êtes en <b>période d'essai</b>.</span><br/><br/><span style='font-size:80%;'>Dans ce cadre, tous les documents comptables (devis/facture/ticket...) que vous créez sont des documents de test.<br/><br/>Tous seront supprimés quand vous choisirez votre plan de tarification.</span></div>").appendTo(contentElement)
                $("<div style='padding-top:25px;'/>").appendTo(contentElement).dxCtrlButton({
                    text: textBt,
                    width: "100%",
                    onClick: function (e) {
                        isValidate = true
                        popVisu.hide()
                        funcValide()
                    }
                })
            }
            //var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            //    target: target,
            //    position: "bottom",
            //    width: 350,
            //    contentTemplate: function (contentElement) {
            //    },
            //    onHiding: function (e) {
            //        if (!isValidate) jaugeDemarrage.mHide()
            //    }
            //}).dxCtrlTooltip("instance")
            //tt.show()
        } else if (idTypeCom == 1 && !Me.objet.bddRef.objCptCli.objetMetier.hasDevis()) {
            Me.objet.bddRef.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Votre offre ne vous permet pas<br/>de créer des devis.<br/>Accédez à votre compte pour modifier votre offre", null, 0)
        } else if (idTypeCom == 2 && !Me.objet.bddRef.objCptCli.objetMetier.hasCommande()) {
            Me.objet.bddRef.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Votre offre ne vous permet pas<br/>de créer des commandes.<br/>Accédez à votre compte pour modifier votre offre", null, 0)
        } else if (idTypeCom == 3 && !Me.objet.bddRef.objCptCli.objetMetier.hasFacture()) {
            Me.objet.bddRef.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Votre offre ne vous permet pas<br/>de créer des factures.<br/>Accédez à votre compte pour modifier votre offre", null, 0)
        } else if (idTypeCom == 5 && !Me.objet.bddRef.objCptCli.objetMetier.hasCaisse()) {
            Me.objet.bddRef.objCptCli.objetMetier.mSignaleLimiteAbonnement(target, "Votre offre ne vous permet pas<br/>de créer des tickets.<br/>Accédez à votre compte pour modifier votre offre", null, 0)
        } else { funcValide() }
    }
    this.mSignaleLimiteAbonnement = function (target, message, txtBt, idDisplay, funcDisplayAchat) {
        var popVisu = null
        if (target && target.closest("body").length > 0) {
            popVisu = $("<div/>").appendTo("body").dxCtrlTooltip({
                width: 450,
                target: target,
                contentTemplate: function (contentElement) {
                    contentTemplate(contentElement)
                }
            }).dxCtrlTooltip("instance")
            popVisu.show()
        } else {
            popVisu = $("<div/>").appendTo("body").dxCtrlPopupBase({
                showMaximize: false,
                height: "auto",
                width: 500,
                contentTemplate: function (contentElement) {
                    contentTemplate(contentElement)
                }
            }).dxCtrlPopupBase("instance")
            popVisu.show()
        }

        function contentTemplate(contentElement) {
            contentElement.css("padding", "25px")
            contentElement.css("font-size", "120%")
            contentElement.css("white-space", "normal")
            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='min-width:1px;font-size:300%;padding-right:5px;'><i class='fas fa-triangle-exclamation'></i></td>").appendTo($Tr)
            var $Td = $("<td style='width:100%;text-align:left;'>" + message + "</td>").appendTo($Tr)
            if (txtBt == null) {
                if (Me.objet.bddRef.objCptCli.data.offre_essai == "1" || Me.objet.bddRef.isDemo) {
                    txtBt = "Modifier mes fonctionnalités disponibles"
                } else {
                    txtBt = "Modifier mon offre"
                }
            }
            $("<div style='width:100%;padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                text: txtBt,
                width: "100%",
                onClick: function (e) {
                    if (typeof funcDisplayAchat != 'undefined') {
                        funcDisplayAchat()
                    } else {
                        if (Me.objet.bddRef.objCptCli.data.offre_essai == "1" || Me.objet.bddRef.isDemo) {
                            var dxEssaiPopup = $("<div/>").appendTo("body").dxCtrlOffreEssaiPopup({
                                bddCtrl: Me.objet.bddRef,
                                showBienvenue: true,
                                txtButton: "Fermer",
                                showAbonnement: true,
                                onValide: function () {
                                    if (dxEssaiPopup.offreChange && dxEssaiPopup.gestionOffre != null) {
                                        dxEssaiPopup.gestionOffre.mSaveForEssai(function () {
                                            jaugeDemarrage.mShow()
                                            window.setTimeout(function () {
                                                forcerFermetureNavigateur = true;
                                                window.location.reload()
                                            }, 300)
                                        })
                                    }
                                    //if (dxEssaiPopup.offreChange) {
                                    //    jaugeDemarrage.mShow()
                                    //    window.setTimeout(function () { mStart() }, 300)
                                    //}
                                }
                            }).dxCtrlOffreEssaiPopup("instance")
                        } else {
                            $("<div/>").appendTo("body").dxCtrlAchatPopup({
                                bddCtrl: bddRef,
                                idSelectedOnglet: 1
                            })
                            //$("<div/>").appendTo("body").dxCtrlOffrePopup({
                            //    bddCtrl: Me.objet.bddRef,
                            //    idSelectedOnglet: idDisplay
                            //})
                        }
                    }
                    popVisu.hide()
                }
            })
        }
    }
    //this.mGetPlanCourant = function () {
    //    //parametre.lstTarifPlan
    //    return parametre.plan.lstPlan.filter(function (o) { return o.id_type_plan == objet.data.id_type_plan })[0]
    //}
    //#endregion "PLAN"

    //#region "OFFRE"
    var _lstFonctionnalite = null
    this.mGetLstFonctionnalite = function () {
        //return Me.objet.bddRef.mGetArray("compte_client_fonctionnalite")
        if (_lstFonctionnalite == null) {
            _lstFonctionnalite = []
            Me.objet.bddRef.mAjaxCall({
                command: "getlstfonctionnalitecompteclient",
                async: false
            }, function (data) {
                _lstFonctionnalite = data.lstfonctionnaliteselected
            })
        }
        return _lstFonctionnalite
    }
    this.mGetLstIdTypeFonctionnalite = function () {
        var lstId = []
        this.mGetLstFonctionnalite().forEach(function (o) { lstId.push(o.id_type_fonctionnalite) })
        return lstId
    }
    this.mGetLstIdTypeFonctionnaliteEssai = function () {
        var offreMax = null
        Me.objet.bddRef.tarif.lst_offre.forEach(function (offre) {
            if (offre.id_offre != 99) offreMax = offre
        })
        return offreMax.id_type_fonctionnalite
    }
    this.hasFonctionnaliteET = function (lstIdTypeFonctionnaliteET) {
        return this.mGetLstFonctionnalite().filter(function (o) { return lstIdTypeFonctionnaliteET.contains(parseInt(o.id_type_fonctionnalite)) }).length == lstIdTypeFonctionnaliteET.length
    }
    this.hasFonctionnaliteOU = function (lstIdTypeFonctionnaliteOU) {
        return this.mGetLstFonctionnalite().filter(function (o) { return lstIdTypeFonctionnaliteOU.contains(parseInt(o.id_type_fonctionnalite)) }).length > 0
    }

    //test présence fonctionnalite
    function mHasFonctionnalite(idTypeFonctionnalite) {
        //if (objet.bddRef.nom_base.endsWith("_aagest")) {
        //    try {
        //        return objet.bddRef.tarif.lst_fonctionnalite.filter(function (o) { return o.id_type_fonctionnalite == idTypeFonctionnalite })[0].dispo_gest == "1"
        //    } catch (e) {
        //        //debugger;
        //    }
        //} else {
        return Me.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == idTypeFonctionnalite }).length > 0
        //}
    }
    this.hasAdhesion = function () {
        return mHasFonctionnalite(26)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 0 }).length > 0
    }
    this.hasAccesFonctionnaliteImportAuto = function () {
        return objet.bddRef.tarif.lst_fonctionnalite.filter(function (o) { return o.id_type_fonctionnalite == 28 }).length > 0 || objet.bddRef.tarif.lst_id_type_fonctionalite_supplementaire.contains("28")
    }
    this.hasImportAuto = function () {
        return mHasFonctionnalite(28)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 0 }).length > 0
    }
    this.hasBdd = function () {
        return mHasFonctionnalite(0)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 0 }).length > 0
    }
    this.hasCarto = function () {
        return mHasFonctionnalite(17)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 17 }).length > 0
    }
    this.hasPersoChamp = function () {
        return mHasFonctionnalite(15)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 15 }).length > 0
    }
    this.hasVueTemplate = function () {
        return mHasFonctionnalite(21)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 21 }).length > 0
    }
    this.hasMajLot = function () {
        return mHasFonctionnalite(22)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 21 }).length > 0
    }
    this.hasScore = function () {
        return mHasFonctionnalite(18)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 18 }).length > 0
    }
    this.hasFiltreSimple = function () {
        return mHasFonctionnalite(23)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 18 }).length > 0
    }
    this.hasFiltreAvance = function () {
        return mHasFonctionnalite(24)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 18 }).length > 0
    }
    this.hasBox = function () {
        return mHasFonctionnalite(19)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 19 }).length > 0
    }
    this.hasPastille = function () {
        return mHasFonctionnalite(16)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 16 }).length > 0
    }
    this.hasDossier = function () {
        return mHasFonctionnalite(1)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 1 }).length > 0
    }
    this.hasPipeline = function () {
        return mHasFonctionnalite(2)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 2 }).length > 0
    }
    this.hasNote = function () {
        return mHasFonctionnalite(3)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 3 }).length > 0
    }
    this.hasDevis = function () {
        return mHasFonctionnalite(4)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 4 }).length > 0
    }
    this.hasCommande = function () {
        return mHasFonctionnalite(5)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 5 }).length > 0
    }
    this.hasFacture = function () {
        return mHasFonctionnalite(6)
        return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 6 }).length > 0
    }
    this.hasTicket = function () {
        return mHasFonctionnalite(7)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 7 }).length > 0
    }
    this.hasDocCpt = function () {
        return this.hasDevis() || this.hasCommande() || this.hasFacture() || this.hasCaisse()
    }
    this.hasCaisse = function () {
        return mHasFonctionnalite(33)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasEmail = function () {
        return mHasFonctionnalite(8)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 8 }).length > 0
    }
    this.hasOptionDomaineDedie = function () {
        return this.hasEmail() && Me.data.domaine_dedie_date_fin != null && Me.data.domaine_dedie_date_fin > parametre.dateNow
    }
    this.hasCourrier = function () {
        return mHasFonctionnalite(9)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 9 }).length > 0
    }
    this.hasSms = function () {
        return mHasFonctionnalite(10)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 10 }).length > 0
    }
    this.hasProjet = function () {
        return mHasFonctionnalite(11)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 11 }).length > 0
    }
    this.hasDates = function () {
        return mHasFonctionnalite(25) || mHasFonctionnalite(27)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 11 }).length > 0
    }
    this.hasOptionPortail = function () {
        return this.hasDates() && Me.data.acces_portail_date_fin != null && Me.data.acces_portail_date_fin > parametre.dateNow
    }
    this.hasAgenda = function () {
        return mHasFonctionnalite(12)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 12 }).length > 0
    }
    //this.hasLocation = function () {
    //    return mHasFonctionnalite(13)
    //    //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 13 }).length > 0
    //}
    //this.hasSupport = function () {
    //    return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 14 }).length > 0
    //}
    this.hasPlaniti = function () {
        return mHasFonctionnalite(20)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasHebergement = function () {
        return mHasFonctionnalite(29)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasHebergementIcal = function () {
        return mHasFonctionnalite(30)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasHebergementReservationInternet = function () {
        return mHasFonctionnalite(31)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasHebergementServiceEtRecap = function () {
        return mHasFonctionnalite(32)
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }
    this.hasSondage = function () {
        return mHasFonctionnalite(34) && (parametre.code_appli == "ppmasc" || parametre.code_appli == "invi")
        //return this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 20 }).length > 0
    }

    this.mGetChampAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }

    this.mGetNbElement = function () {
        if (this.objet.data.offre_id_type == 0) {
            return 99999
        } else {
            return this.objet.data.nb_element
            //return 10
            //var fonctionnalite = this.mGetLstFonctionnalite().filter(function (o) { return o.id_type_fonctionnalite == 13 })[0]
            //return fonctionnalite.nb_element
        }
    }
    this.mGetLstAccesPonctuelActif = function (dateFin) {
        if (typeof dateFin == 'undefined') dateFin = new Date(parametre.dateNow)
        return Me.objet.bddRef.mGetArray("compte_client_acces").filter(function (cptCliAcces) { return dateFin >= cptCliAcces.date_debut.to000000() && dateFin <= cptCliAcces.date_fin.to235959() }).length
    }
    //#endregion "OFFRE"

    this.mGetMaxTailleEspaceGB = function () {
        return parseInt(objet.data.palier_gb * Me.objet.bddRef.baseAppli.para.nb_gb_par_palier)
    }

    this.hasServeurSmtpDedie = function () {
        return (objet.data.smtp_dedie_date_fin != null && objet.data.smtp_dedie_date_fin >= parametre.dateNow)
    }

    this.mGetLstPeriodeCreditSms = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        return Me.objet.bddRef.mGetArray("credit_sms").filter(function (dataSms) {
            return (dat >= dataSms.date_debut && dat <= dataSms.date_fin && dataSms.nb_total - dataSms.nb_utilise > 0)
        }).sort(function (o1, o2) { return o2.date_fin - o2.date_fin })
    }

    this.mGetNbSmsDispo = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        var tot = 0
        var lst = this.mGetLstPeriodeCreditSms(dat)
        lst.forEach(function (dataSms) {
            tot += parseInt(dataSms.nb_total) - parseInt(dataSms.nb_utilise)
        })
        return tot
    }

    this.mUseSms = function (nb) {
        this.mGetLstPeriodeCreditSms().forEach(function (dataSms) {
            if (nb > 0) {
                var rest = dataSms.nb_total - dataSms.nb_utilise
                if (rest >= nb) {
                    dataSms.nb_utilise = parseInt(dataSms.nb_utilise) + nb
                } else {
                    dataSms.nb_utilise = dataSms.nb_total
                    nb = nb - rest
                }
                Me.objet.bddRef.getObjet(dataSms).mSaveChamp("nb_utilise")
            }
        })
    }

    this.mGetLstPeriodeCreditSmsHtml = function (dat) {
        var txt = ""
        var lst = this.mGetLstPeriodeCreditSms(dat)
        if (lst.length > 0) {
            lst.forEach(function (dataSms) {
                var nb = dataSms.nb_total - dataSms.nb_utilise
                txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; du " + dataSms.date_debut.toDDMMAA() + " au " + dataSms.date_fin.toDDMMAA() + " &bull; " + nb + " crédit" + ((nb > 0) ? "s" : "") + " sms"
            })
        }
        return ((txt.length > 0) ? txt : "(aucun crédit sms)")
    }
    //#endregion "CREDIT SMS"

    this.mGetLstPeriodeCreditEmail = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        return Me.objet.bddRef.mGetArray("credit_email").filter(function (dataEmail) {
            return (dat >= dataEmail.date_debut && dat <= dataEmail.date_fin && dataEmail.nb_total - dataEmail.nb_utilise > 0)
        }).sort(function (o1, o2) { return o2.date_fin - o2.date_fin })
    }

    this.mGetNbEmailDispo = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        var tot = 0
        var lst = this.mGetLstPeriodeCreditEmail(dat)
        lst.forEach(function (dataEmail) {
            tot += parseInt(dataEmail.nb_total) - parseInt(dataEmail.nb_utilise)
        })
        return tot
    }

    this.mUseEmail = function (nb) {
        nb = parseInt(nb)
        this.mGetLstPeriodeCreditEmail().forEach(function (dataEmail) {
            if (nb > 0) {
                var rest = dataEmail.nb_total - dataEmail.nb_utilise
                if (rest >= nb) {
                    dataEmail.nb_utilise = parseInt(dataEmail.nb_utilise) + nb
                } else {
                    dataEmail.nb_utilise = dataEmail.nb_total
                    nb = nb - rest
                }
                Me.objet.bddRef.getObjet(dataEmail).mSaveChamp("nb_utilise")
            }
        })
    }

    this.mGetLstPeriodeCreditEmailHtml = function (dat) {
        var txt = ""
        var lst = this.mGetLstPeriodeCreditEmail(dat)
        if (lst.length > 0) {
            lst.forEach(function (dataEmail) {
                var nb = dataEmail.nb_total - dataEmail.nb_utilise
                txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; du " + dataEmail.date_debut.toDDMMAA() + " au " + dataEmail.date_fin.toDDMMAA() + " &bull; " + nb + " crédit" + ((nb > 0) ? "s" : "") + " emails"
            })
        }
        return ((txt.length > 0) ? txt : "(aucun crédit email)")
    }
    //#endregion "CREDIT EMAIL"

    this.mGetLstPeriodeCreditTestEmail = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        return Me.objet.bddRef.mGetArray("credit_test_email").filter(function (dataTestEmail) {
            return (dat >= dataTestEmail.date_debut && dat <= dataTestEmail.date_fin && dataTestEmail.nb_total - dataTestEmail.nb_utilise > 0)
        }).sort(function (o1, o2) { return o2.date_fin - o2.date_fin })
    }

    this.mGetNbTestEmailDispo = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        var tot = 0
        var lst = this.mGetLstPeriodeCreditTestEmail(dat)
        lst.forEach(function (dataTestEmail) {
            tot += parseInt(dataTestEmail.nb_total) - parseInt(dataTestEmail.nb_utilise)
        })
        return tot
    }

    this.mUseTestEmail = function (nb) {
        this.mGetLstPeriodeCreditTestEmail().forEach(function (dataTestEmail) {
            if (nb > 0) {
                var rest = dataTestEmail.nb_total - dataTestEmail.nb_utilise
                if (rest >= nb) {
                    dataTestEmail.nb_utilise = parseInt(dataTestEmail.nb_utilise) + nb
                } else {
                    dataTestEmail.nb_utilise = dataTestEmail.nb_total
                    nb = nb - rest
                }
                Me.objet.bddRef.getObjet(dataTestEmail).mSaveChamp("nb_utilise")
            }
        })
    }

    this.mGetLstPeriodeCreditTestEmailHtml = function (dat) {
        var txt = ""
        var lst = this.mGetLstPeriodeCreditTestEmail(dat)
        if (lst.length > 0) {
            lst.forEach(function (dataTestEmail) {
                var nb = dataTestEmail.nb_total - dataTestEmail.nb_utilise
                txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; du " + dataTestEmail.date_debut.toDDMMAA() + " au " + dataTestEmail.date_fin.toDDMMAA() + " &bull; " + nb + " crédit" + ((nb > 0) ? "s" : "") + " sms"
            })
        }
        return ((txt.length > 0) ? txt : "(aucun crédit test email)")
    }
    //#endregion "CREDIT TEST EMAIL"


    this.mGetLstPeriodeCreditFacturation = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        return Me.objet.bddRef.mGetArray("credit_facturation").filter(function (dataFacturation) {
            return (dat >= dataFacturation.date_debut && dat <= dataFacturation.date_fin && dataFacturation.nb_total - dataFacturation.nb_utilise > 0)
        }).sort(function (o1, o2) { return o2.date_fin - o2.date_fin })
    }

    this.mGetNbCreditFacturationDispo = function (dat) {
        if (typeof dat == 'undefined') dat = parametre.dateNow
        var tot = 0
        var lst = this.mGetLstPeriodeCreditFacturation(dat)
        lst.forEach(function (dataFacturation) {
            tot += parseInt(dataFacturation.nb_total) - parseInt(dataFacturation.nb_utilise)
        })
        return tot
    }

    this.mUseCreditFacturation = function (nb) {
        this.mGetLstPeriodeCreditFacturation().forEach(function (dataFacturation) {
            if (nb > 0) {
                var rest = dataFacturation.nb_total - dataFacturation.nb_utilise
                if (rest >= nb) {
                    dataFacturation.nb_utilise = parseInt(dataFacturation.nb_utilise) + nb
                } else {
                    dataFacturation.nb_utilise = dataFacturation.nb_total
                    nb = nb - rest
                }
                Me.objet.bddRef.getObjet(dataFacturation).mSaveChamp("nb_utilise")
            }
        })
    }

    this.mGetLstPeriodeCreditFacturationHtml = function (dat) {
        var txt = ""
        var lst = this.mGetLstPeriodeCreditFacturation(dat)
        if (lst.length > 0) {
            lst.forEach(function (dataFacturation) {
                var nb = dataFacturation.nb_total - dataFacturation.nb_utilise
                txt += ((txt.length > 0) ? "<br/>" : "") + "&bull; du " + dataFacturation.date_debut.toDDMMAA() + " au " + dataFacturation.date_fin.toDDMMAA() + " &bull; " + nb + " crédit" + ((nb > 0) ? "s" : "") + " sms"
            })
        }
        return ((txt.length > 0) ? txt : "(aucun crédit sms)")
    }
    //#endregion "CREDIT SMS"


    this.mAddTelMobileSiVide = function (dataTel) {
        if (dataTel != null && dataTel.tel_number.length > 0) {
            objet.data.mob_code_pays = dataTel.tel_code_pays
            objet.data.mob_number = dataTel.tel_number
            objet.data.mob_complet = dataTel.tel_complet
            objet.data.mob_sms = dataTel.tel_sms
            objet.data.mob_error = dataTel.tel_error
            objet.data.mob_num_type = dataTel.tel_num_type
            objet.mSave()
        }
    }

    //#region CREATION COLUMN DXDATAGRID num
    this.mGetColumnDataGrid = function (lstCol, dxVirtualGrid) {
        //Nom
        var col = {
            caption: "Nom société",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.nom == null || obj.data.nom.length == 0) { return "(vide)" }
                else { return obj.data.nom }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (obj.data.nom == null || obj.data.nom.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.nom) }
            }
        }
        lstCol.push(col)
        //nom_contact & prenom_contact
        var col = {
            caption: "Nom & prénom",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if ((obj.data.nom_contact == null && obj.data.prenom_contact == null) || (obj.data.nom_contact.length == 0 && obj.data.prenom_contact.length == 0)) {
                    return "(vide)"
                } else { return obj.data.nom_contact + ((obj.data.nom_contact != null & obj.data.nom_contact.length > 0 && obj.data.prenom_contact != null && obj.data.prenom_contact.length > 0) ? " " : "") + obj.data.prenom_contact }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if ((obj.data.nom_contact == null && obj.data.prenom_contact == null) || (obj.data.nom_contact.length == 0 && obj.data.prenom_contact.length == 0)) {
                    container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>")
                } else {
                    container.text(obj.data.nom_contact + ((obj.data.nom_contact != null & obj.data.nom_contact.length > 0 && obj.data.prenom_contact != null && obj.data.prenom_contact.length > 0) ? " " : "") + obj.data.prenom_contact)
                }
            }
        }
        lstCol.push(col)
        //nom_base
        var col = {
            caption: "Nom base",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: false,
            showWhenGrouped: false,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.nom_base == null || obj.data.nom_base.length == 0) { return "(vide)" }
                else { return obj.data.nom_base }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (obj.data.nom_base == null || obj.data.nom_base.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.nom_base) }
            }
        }
        lstCol.push(col)
        //ad1,cp,ville,pays
        var col = {
            caption: "Adresse postale",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var adr = (new cAdresse(obj.data)).mGetAdresseCourt();
                if (adr.length == 0) { return "(aucune adresse)" }
                else if (typeof obj.data.pays != 'undefined' && obj.data.pays != null && obj.data.pays.length > 0) { return obj.data.pays }
                else { return "(aucun pays)" }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                var adr = (new cAdresse(obj.data)).mGetAdresseCourt();
                if (adr.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>adresse</span>") }
                else {
                    container.text(adr)
                }
            }
        }
        lstCol.push(col)
        //adresse_email
        var col = {
            caption: "Adresse email",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (typeof obj.data.adresse_email == 'undefined' || obj.data.adresse_email == null || obj.data.adresse_email.length == 0) { return "(aucun email)" }
                else { return obj.data.adresse_email }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (typeof obj.data.adresse_email == 'undefined' || obj.data.adresse_email == null || obj.data.adresse_email.length == 0) {
                    container.html("<span style='opacity:0.1;text-decoration:line-through;'>email</span>")
                }
                else { container.html("<u>" + obj.data.adresse_email + "</u>") }
            }
        }
        lstCol.push(col)
        //tel_code_pays && tel_num
        var col = {
            caption: "Téléphone",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.tel_code_pays, obj.data.tel_sms)
                if (!tel.hasValue()) { return "(aucun téléphone)" }
                else { return tel.mGetValueMiseEnForme() }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                var tel = new cTelephone(obj.data.tel_code_pays, obj.data.tel_sms)
                if (!tel.hasValue()) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>téléphone</span>") }
                else { container.html("" + tel.mGetValueMiseEnForme() + "") }
            }
        }
        lstCol.push(col)
        //mob_code_pays && mob_sms
        var col = {
            caption: "Mobile",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.mob_code_pays, obj.data.mob_sms)
                if (!tel.hasValue()) { return "(aucun mobile)" }
                else { return tel.mGetValueMiseEnForme() }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                var tel = new cTelephone(obj.data.mob_code_pays, obj.data.mob_sms)
                if (!tel.hasValue()) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>mobile</span>") }
                else { container.html("" + tel.mGetValueMiseEnForme() + "") }
            }
        }
        lstCol.push(col)
        //site_web
        var col = {
            caption: "Site web",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (typeof obj.data.site_web == 'undefined' && obj.data.site_web == null) { return "(aucun site)" }
                else { return obj.data.site_web }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (typeof obj.data.site_web == 'undefined' && obj.data.site_web == null) {
                    container.html("<span style='opacity:0.1;text-decoration:line-through;'>site web</span>")
                } else { container.text(obj.data.site_web) }
            }
        }
        lstCol.push(col)
        //tva_intra
        var col = {
            caption: "TVAintra",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.tva_intra == null || obj.data.tva_intra.length == 0) { return "(vide)" }
                else { return obj.data.tva_intra }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (obj.data.tva_intra == null || obj.data.tva_intra.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.tva_intra) }
            }
        }
        lstCol.push(col)
        //derniere_date_connexion
        var col = {
            caption: "Dernière date CNX",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.derniere_date_connexion == null) { return "(vide)" }
                else { return new Date(obj.data.derniere_date_connexion) }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(options.data)
                if (obj.data.derniere_date_connexion == null) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.derniere_date_connexion.toFrenchDateTime()) }
            }
        }
        lstCol.push(col)
        //dossier
        var col = {
            caption: "Dossier",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: false,
            showWhenGrouped: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
                if (typeof options.data.id_table == 'undefined') return;
                var obj = Me.mGetObjetStrCon(options.data)
                Me.objet.bddRef.mAjaxCall({ command: "getdataslstdossierfromelement", "idtable": options.data.id_table, "id": options.data.id }, function (data) {
                    data.dossier_element = JSON.parse(data.dossier_element)
                    //if (typeof data.dossier_element == 'undefined') data.dossier_element = []
                    if (data.dossier_element.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>dossier</span>") }
                    else {
                        var txt = ""
                        data.dossier_element.forEach(function (dossEle) {
                            txt += ((txt.length > 0) ? ", " : "") + Me.objet.bddRef.getObjet("dossier", dossEle.id_dossier).data.nom
                        })
                        container.html(txt)
                    }
                })
            }
        }
        lstCol.push(col)
    }
    //#endregion CREATION COLUMN DXDATAGRID 

    this.mGetPhraseHtmlChampManquantClientForDocCpt = function () {
        var txtManque = ""
        if (objet.data.nom != null && objet.data.nom.length > 0) {
            //société //nom/cp/ville/tvaIntra
            if (objet.data.nom == null || objet.data.nom.length == 0) txtManque = "nom société"
            if (objet.data.cp == null || objet.data.cp.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "code postal"
            if (objet.data.ville == null || objet.data.ville.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "ville"
            if (objet.data.pays == null || objet.data.pays.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "pays"
            //if (objet.data.tva_intra == null || objet.data.tva_intra.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "TVA intracommunautaire"
            ////if (txtManque.length > 0) {
            ////    txtManque = "Pour générer votre commande,<br/>vous devez remplir les champs suivants:<br/><b>" + txtManque + "</b>"
            ////}
        } else {
            //particulier //nom/prénom/cp/ville
            if (objet.data.nom_contact == null || objet.data.nom_contact.length == 0) txtManque = "nom contact"
            if (objet.data.cp == null || objet.data.cp.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "code postal"
            if (objet.data.ville == null || objet.data.ville.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "ville"
            if (objet.data.pays == null || objet.data.pays.length == 0) txtManque += ((txtManque.length > 0) ? ", " : "") + "pays"
            //if (txtManque.length > 0) {
            //    txtManque = "Pour générer votre commande,<br/>vous devez remplir les champs suivants:<br/><b>" + txtManque + "</b>"
            //}
        }
        return txtManque
    }

    this.mGetHtmlCoordonneesFacturation = function () {
        var result = ""
        if (objet.data.nom != null && objet.data.nom.length > 0) {
            //société //nom/cp/ville/tvaIntra
            result = objet.data.nom + "<br/>" +
                objet.data.cp + " " + objet.data.ville + ", " + objet.data.pays + "<br/>" +
                "tvaIntra:" + objet.data.tva_intra
        } else {
            //particulier //nom/prénom/cp/ville
            result = objet.data.nom_contact + " " + objet.data.prenom_contact + "<br/>" +
                objet.data.cp + " " + objet.data.ville + ", " + objet.data.pays + "<br/>"
        }
        return result
    }

    this.mUpdateOffreEssai = function (idTypeOffre, lstIdTypeFonc, funcOk) {
        var lstIdTypeFonctNbEle = ""
        if (lstIdTypeFonc != null) {
            Me.objet.data.offre_id_type = 99
            lstIdTypeFonc.forEach(function (idTypeFonct) {
                lstIdTypeFonctNbEle += ((lstIdTypeFonctNbEle.length > 0) ? "|" : "") + idTypeFonct + ",0"
            })
        } else {
            var offre = Me.objet.bddRef.tarif.lst_offre.filter(function (o) { return o.id_type_offre == idTypeOffre })[0]
            Me.objet.data.offre_id_type = idTypeOffre
            offre.id_type_fonctionnalite.forEach(function (idTypeFonct) {
                lstIdTypeFonctNbEle += ((lstIdTypeFonctNbEle.length > 0) ? "|" : "") + idTypeFonct + ",0"
            })
        }
        Me.objet.bddRef.mAjaxCall({
            command: "savecompteclientfonctionnalite",
            id_type_offre: Me.objet.data.offre_id_type,
            lst_id_type_fonctionnalite_nb_element: lstIdTypeFonctNbEle
        }, function (data) {
            Me.objet.bddRef.mReloadTable("compte_client_fonctionnalite", function () {
                funcOk()
            })
        })
    }

    this.mRemiseA0Environnement = function () {
        mConfirmPopup("<div class='blink' style='color:red;text-align:center;'><b>⚠ Vous allez remettre votre environnement à 0 ⚠<br/>⚠ et perdre toutes vos données actuelles ⚠</b></div><div style='text-align:center;'><br/>Vous serez redirigé sur la page de login à la fin de la réinitialisation.</div>", function () {
            jaugeDemarrage.mShow()
            Me.objet.bddRef.mAjaxCall({ command: "remisea0bdd", timeout: 300000 }, function (data) {
                mNotify("Votre environnement à été remis à 0", "success", 30000)
                window.setTimeout(function () { mRedirectOnLogin("") }, 500)
            }, null, function () {
                mNotify("Impossible de remettre à 0 votre environnement", "error", 10000)
                jaugeDemarrage.mHide()
            })
        }, "Confirmer", function () {

        }, "Annuler", null, true, "Réinitialiser votre environnement")
    }

}